<!-- 品牌复盘 -->
<template>
  <div>
    <div class="queryArea clearfix" style="margin-bottom: 10px;">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">月份：</span>
          <el-date-picker
            type="month"
            v-model="queryForm.time"
            value-format="yyyy-MM"
            size="mini"
            @change="queryHandle"
          ></el-date-picker>
        </div>
        <div class="scan_box">
          <el-button size="mini" @click="infoHandle('add')" type="primary"
            >新增复盘信息</el-button
          >
        </div>
      </div>
    </div>

    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum,
      }"
      @setResetPageNum="(e) => (resetPageNum = e)"
      :totalCount="totalCount"
    >
      <el-table-column label="操作" slot="handle" align="center" width="120">
        <template slot-scope="{ row }">
          <el-button
            type="text"
            @click="infoHandle(row)"
            class="fontColor_warning"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="deleteHandle(row)"
            class="fontColor_danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </tablePageComp>

    <el-dialog
      :title="(operateType == 'add' ? '新增' : '修改') + '复盘信息'"
      :visible.sync="replayVis"
      width="600px"
      :before-close="handleClose"
      top="2vh"
      append-to-body
    >
      <el-form ref="formData" :model="formData" :show-message="false">
        <el-form-item label="复盘日期" prop="time" required>
          <el-date-picker
            v-model="formData.time"
            type="month"
            value-format="yyyy-MM"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="账号和资质">
          <el-input
            type="textarea"
            :rows="4"
            v-model="formData.account"
          ></el-input>
        </el-form-item>
        <el-form-item label="操作情况">
          <el-input
            type="textarea"
            :rows="4"
            v-model="formData.operate"
          ></el-input>
        </el-form-item>
        <el-form-item label="存在的问题">
          <el-input
            type="textarea"
            :rows="4"
            v-model="formData.problem"
          ></el-input>
        </el-form-item>
        <el-form-item label="规划和方案">
          <el-input
            type="textarea"
            :rows="4"
            v-model="formData.scheme"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="replayVis = false" :loading="btnLoading"
          >取消</el-button
        >
        <el-button @click="submitBtn" type="primary" :loading="btnLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["contractProp"],
  data() {
    return {
      queryForm: {
        time: "",
      },
      columnsList: [
        {
          label: "操作",
          slotName: "handle",
        },
        {
          label: "复盘时间",
          prop: "time",
          width: 100,
        },
        {
          label: "账号和资质",
          prop: "account",
          align: "left",
        },
        {
          label: "操作情况",
          prop: "operate",
          align: "left",
        },
        {
          label: "存在的问题",
          prop: "problem",
          align: "left",
        },
        {
          label: "规划和方案",
          prop: "scheme",
          align: "left",
        },
        {
          label: "提交时间",
          prop: "create_time",
          width: 150,
        },
      ],
      dataList: [],
      updateDataTag: false,
      resetPageNum: true,
      totalCount: 0,
      userId: this.$tools.sessionGetStore("user_id"),
      replayVis: false,
      operateType: "",
      formData: {
        time: "",
        account: "",
        operate: "",
        problem: "",
        scheme: "",
      },
      btnLoading: false,
    };
  },
  methods: {
    deleteHandle(param) {
      this.$confirm("确认删除此条信息吗?", "提示", {
        type: "error",
      }).then(() => {
        this.$api
          .deleteBrandReplay({ id: param.id })
          .then(() => {
            this.updateDataTag = !this.updateDataTag;
            this.resetPageNum = false;
          })
          .catch((error) => {
            console.log(error);
            this.$message.error("删除失败");
          });
      });
    },
    infoHandle(param) {
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = "";
      });
      if (param == "add") {
        this.operateType = "add";
      } else {
        this.operateType = "modify";
        Object.keys(this.formData).forEach((key) => {
          this.formData[key] = param[key];
        });
        this.formData.id = param.id;
      }
      this.replayVis = true;
    },
    submitBtn() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let paramObj = {
              update_user: this.userId,
              customer_id: this.contractProp.customer_id,
              // customer_file_id: this.contractProp.customer_file_id,
            },
            apiName = "";
          Object.keys(this.formData).forEach((key) => {
            paramObj[key] = this.formData[key];
          });
          if (this.operateType == "add") {
            paramObj.create_user = this.userId;
            apiName = "addBrandReplay";
          } else {
            apiName = "modifyBrandReplay";
          }
          this.btnLoading = true;
          this.$api[apiName](paramObj)
            .then((res) => {
              this.updateDataTag = !this.updateDataTag;
              this.resetPageNum = false;
              this.replayVis = false;
            })
            .catch((error) => {
              console.log(error);
              this.$message.error("更新复盘信息失败");
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    queryHandle() {
      this.$tools.debounceFunc(() => {
        this.updateDataTag = !this.updateDataTag;
      }, 300);
    },
    dataQueryFunc() {
      let paramObj = {
        customer_id: this.contractProp.customer_id,
        // customer_file_id: this.contractProp.customer_file_id,
      };
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key]) {
          paramObj[key] = this.queryForm[key];
        }
      });

      return {
        apiName: "getBrandReplay",
        paramObj: paramObj,
        success: function(response, callBack) {
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];
            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });
            arr.push(obj);
          }
          this.dataList = arr;
          this.totalCount = response.data.data.total;
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          if (callBack) {
            callBack();
          }
        },
      };
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>

<style></style>
